import React, { useState } from "react";
import { amazonApi } from "../../services/api/omni/amazon";

const todayIso = () => {
  const d = new Date();
  return d.toISOString().slice(0, 10);
};

// German marketplace IDs
const DEFAULT_MARKETPLACES = "A1PA6795UKMFR9";

export default function AmazonReportsPage() {
  const [reportType, setReportType] = useState(
    "GET_FLAT_FILE_ALL_ORDERS_DATA_BY_ORDER_DATE_GENERAL",
  );
  const [marketplaceIds, setMarketplaceIds] = useState(DEFAULT_MARKETPLACES);
  const [dataStartTime, setDataStartTime] = useState(`${todayIso()}T00:00:00Z`);
  const [dataEndTime, setDataEndTime] = useState(`${todayIso()}T23:59:59Z`);
  const [reportOptionsRaw, setReportOptionsRaw] = useState("");
  const [reportOptionsError, setReportOptionsError] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Requesting report...");

    try {
      const ids = marketplaceIds
        .split(/[,\s]+/)
        .map((s) => s.trim())
        .filter(Boolean);
      if (ids.length === 0) {
        setStatus("Please provide at least one marketplace id");
        return;
      }

      const params = {
        reportType,
        marketplaceIds: ids,
        ...(dataStartTime && { dataStartTime }),
        ...(dataEndTime && { dataEndTime }),
      };

      let reportOptions = undefined;
      if (reportOptionsRaw.trim()) {
        try {
          reportOptions = JSON.parse(reportOptionsRaw);
          setReportOptionsError("");
        } catch {
          setReportOptionsError("Invalid JSON in Report Options");
          setStatus("");
          return;
        }
      }

      const resp = await amazonApi.retrieveReport({ ...params, reportOptions });

      const blob = new Blob([resp.data]);
      // Derive filename locally — Content-Disposition is often not exposed via CORS
      const filename = `${reportType}.tsv`;

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      setStatus("Download started");
    } catch (err) {
      setStatus(String(err));
      console.error(err);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>Amazon Reports (debug)</h2>
      <p style={{ margin: "0 0 16px", fontSize: 13, color: "#555" }}>
        Reference:{" "}
        <a
          href="https://developer-docs.amazon.com/sp-api/docs/report-type-values"
          target="_blank"
          rel="noreferrer"
        >
          Report Type Values
        </a>
        {" · "}
        <a
          href="https://developer-docs.amazon.com/sp-api/docs/marketplace-ids"
          target="_blank"
          rel="noreferrer"
        >
          Marketplace IDs
        </a>
      </p>
      <form
        onSubmit={handleSubmit}
        style={{ display: "grid", gap: 12, maxWidth: 720 }}
      >
        <label>
          Report Type
          <input
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
            style={{ width: "100%" }}
          />
        </label>
        <label>
          Marketplace IDs (comma or space separated)
          <input
            value={marketplaceIds}
            onChange={(e) => setMarketplaceIds(e.target.value)}
            style={{ width: "100%" }}
            placeholder="A1PA6795UKMFR9"
          />
        </label>
        <label>
          Data Start Time (optional, ISO8601)
          <input
            value={dataStartTime}
            onChange={(e) => setDataStartTime(e.target.value)}
            style={{ width: "100%" }}
            placeholder="2026-03-01T00:00:00Z"
          />
        </label>
        <label>
          Data End Time (optional, ISO8601)
          <input
            value={dataEndTime}
            onChange={(e) => setDataEndTime(e.target.value)}
            style={{ width: "100%" }}
            placeholder="2026-03-10T23:59:59Z"
          />
        </label>
        <label>
          Report Options (optional JSON)
          <textarea
            value={reportOptionsRaw}
            onChange={(e) => {
              setReportOptionsRaw(e.target.value);
              setReportOptionsError("");
            }}
            rows={4}
            style={{ width: "100%", fontFamily: "monospace", fontSize: 13 }}
            placeholder='{"key": "value"}'
          />
          {reportOptionsError && (
            <span style={{ color: "#c00", fontSize: 12 }}>
              {reportOptionsError}
            </span>
          )}
        </label>

        <div style={{ display: "flex", gap: 8 }}>
          <button type="submit" style={{ padding: "8px 12px" }}>
            Request & Download
          </button>
          <button
            type="button"
            onClick={() => {
              setReportType("");
              setMarketplaceIds("");
              setDataStartTime("");
              setDataEndTime("");
              setReportOptionsRaw("");
              setReportOptionsError("");
              setStatus("");
            }}
            style={{ padding: "8px 12px" }}
          >
            Reset
          </button>
        </div>
      </form>

      {status && (
        <div
          style={{
            marginTop: 12,
            padding: 10,
            background: "#f4f4f4",
            borderRadius: 6,
          }}
        >
          {status}
        </div>
      )}
    </div>
  );
}
